import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "last_week",
  "use": "last_week-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"last_week\"><path d=\"M10.75 11.083 9 8.75l-1.75 2.333V5.5h-1.5v7.25h2.125L9 11.25l1.125 1.5h2.125V5.5h-1.5zM11.562 2H6.438A4.44 4.44 0 0 0 2 6.438v5.124A4.44 4.44 0 0 0 6.438 16h5.124A4.44 4.44 0 0 0 16 11.562V6.438A4.44 4.44 0 0 0 11.562 2m2.938 9.562a2.94 2.94 0 0 1-2.938 2.938H6.438A2.94 2.94 0 0 1 3.5 11.562V6.438A2.94 2.94 0 0 1 6.438 3.5h5.124A2.94 2.94 0 0 1 14.5 6.438z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol